export default "__VITE_ASSET__2bc0f95f__"